//mrosetti - Necessario per gestire i casi in cui il valore è 0, e deve essere mostrato tale
export function coalesceNumber(value: number | undefined | null, defaultValue: number | undefined | null): number | undefined | null {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  return value;
}
